try {
  require('./bootstrap.css');
} catch(e) {
}



//////////////////
// WEBPACK FOOTER
// ./~/pui-css-bootstrap/index.js
// module id = 3209
// module chunks = 0